<template>
  <section>
    <header class="flex items-center justify-between gap-x-2 mb-2">
      <slot name="actions">
        <slot name="prepend" />
        <div class="flex items-center justify-end gap-x-2">
          <v-btn
            class="h-full"
            color="primary"
            :disabled="disableDownload"
            :loading="isDownloading"
            @click="$emit('download')"
          >
            <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
            <span>Download</span>
          </v-btn>
        </div>
      </slot>
    </header>
    <section class="bg-white">
      <div class="reports-card pt-4 h-full rounded-md shadow-[0_4px_4px_rgba(124,124,150,0.1)]">
        <CfsLoadingOverlay :loading="loading">
          <CfsNoData
            v-if="!$hasSlot('default')"
            title="No visualization available"
            description="We don’t have any visualization for this report, Please generate the report manually."
          />
          <slot v-else :data="data" />
        </CfsLoadingOverlay>
      </div>
    </section>
  </section>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ReportWrapper',
  components: {
    CfsNoData: defineAsyncComponent(() => import('@/framework/elements/CfsNoData.vue')),
  },
  props: {
    data: {
      type: Object as PropType<unknown | null>,
      default: null,
    },
    disableDownload: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDownloading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['download'],
});
</script>

<style scoped lang="scss">
.reports-card {
  border: 1px solid rgba(124, 124, 150, 0.1);
}
</style>
